<div class="json-value-editor" [class.json-value-editor--nested]="isNested">
  @if (label) {
    <div class="field-label">{{ label }}</div>
  }

  <mat-form-field appearance="outline" class="type-field">
    <mat-label>Type</mat-label>
    <mat-select [value]="valueType" (selectionChange)="onTypeChange($event.value)">
      @for (opt of typeOptions; track opt.value) {
        <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @switch (valueType) {
    @case ('string') {
      <mat-form-field appearance="outline" class="scalar-field">
        <mat-label>Tekst</mat-label>
        <textarea
          matInput
          rows="2"
          [ngModel]="value"
          (ngModelChange)="onScalarStringChange($event)"
        ></textarea>
      </mat-form-field>
    }
    @case ('number') {
      <mat-form-field appearance="outline" class="scalar-field">
        <mat-label>Tal</mat-label>
        <input
          matInput
          type="number"
          [ngModel]="value"
          (ngModelChange)="onScalarNumberChange($event)"
        />
      </mat-form-field>
    }
    @case ('boolean') {
      <mat-slide-toggle
        [checked]="value === true"
        (change)="onScalarBooleanChange($event.checked)"
      >
        {{ value === true ? 'Sand' : 'Falsk' }}
      </mat-slide-toggle>
    }
    @case ('null') {
      <span class="null-badge">null</span>
    }
    @case ('object') {
      <div class="nested-block">
        @for (key of objectKeys; track key) {
          <div class="object-row">
            <div class="object-key">{{ key }}</div>
            <button
              mat-icon-button
              type="button"
              aria-label="Slet nøgle"
              (click)="removeObjectKey(key)"
            >
              <mat-icon>delete</mat-icon>
            </button>
            <div class="object-value">
              @if (canNest) {
                <app-json-value-editor
                  [value]="objectValue(key)"
                  [depth]="depth + 1"
                  (valueChange)="onObjectKeyChange(key, $event)"
                />
              } @else {
                <p class="muted">Maks. dybde nået — brug rå JSON.</p>
              }
            </div>
          </div>
        }
        <div class="add-row">
          <mat-form-field appearance="outline">
            <mat-label>Ny nøgle</mat-label>
            <input matInput [(ngModel)]="newObjectKey" />
          </mat-form-field>
          <button mat-stroked-button type="button" (click)="addObjectKey()" [disabled]="!newObjectKey.trim()">
            Tilføj felt
          </button>
        </div>
      </div>
    }
    @case ('array') {
      <div class="nested-block">
        @for (item of arrayItems; track $index) {
          <div class="array-row">
            <span class="array-index">[{{ $index }}]</span>
            <button
              mat-icon-button
              type="button"
              aria-label="Fjern element"
              (click)="removeArrayItem($index)"
            >
              <mat-icon>delete</mat-icon>
            </button>
            <div class="array-value">
              @if (canNest) {
                <app-json-value-editor
                  [value]="item"
                  [depth]="depth + 1"
                  (valueChange)="onArrayItemChange($index, $event)"
                />
              }
            </div>
          </div>
        }
        <div class="add-row add-row--array">
          <mat-form-field appearance="outline">
            <mat-label>Type for nyt element</mat-label>
            <mat-select [(ngModel)]="newArrayItemType">
              @for (opt of typeOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (newArrayItemType === 'string' || newArrayItemType === 'number') {
            <mat-form-field appearance="outline">
              <mat-label>Værdi</mat-label>
              <input matInput [(ngModel)]="newArrayItemValue" />
            </mat-form-field>
          }
          <button mat-stroked-button type="button" (click)="addArrayItem()">Tilføj element</button>
        </div>
      </div>
    }
  }
</div>
